import React from 'react';

/**
 * Cohort row from GET /api/product/v1/cohort (serialized CohortModel).
 * @typedef {Object} CohortRow
 * @property {number} id
 * @property {string} name
 * @property {string|null} [description]
 * @property {string|null} [sourceType]
 * @property {string|null} [sourceRef]
 * @property {string|null} [lastSyncStartedAt] ISO-8601
 * @property {string|null} [lastSyncCompletedAt] ISO-8601
 * @property {string|null} [lastSyncStatus] e.g. pending, running, succeeded, failed
 * @property {string|null} [lastSyncError]
 */

export const cohortSourceTypeSelectOptions = Object.freeze([
    { text: '(none)', value: '' },
    { text: 'braze_segment', value: 'braze_segment' },
    { text: 'csv', value: 'csv' },
]);

/** Autocomplete / select label for a cohort row (lists + pickers). */
export function formatCohortPickerLabel(row) {
    if (!row?.id) return '';

    const label = row.name ? `${row.name} (ID ${row.id})` : `Cohort ${row.id}`;

    return [label, row.sourceType, row.lastSyncStatus && `sync: ${row.lastSyncStatus}`].filter(Boolean).join(' · ');
}

/** Rich dropdown row for MUI Autocomplete cohort pickers. */
export function CohortPickerOption({ cohort }) {
    if (!cohort?.id) {
        return null;
    }

    return (
        <div>
            <strong>{cohort.name || `Cohort ${cohort.id}`}</strong>
            <br />
            <small>
                ID: {cohort.id}
                {cohort.sourceType ? ` · source: ${cohort.sourceType}` : ''}
                {cohort.sourceRef ? ` · ref: ${cohort.sourceRef}` : ''}
                {cohort.lastSyncStatus ? ` · last sync: ${cohort.lastSyncStatus}` : ''}
            </small>
        </div>
    );
}
